import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30dd8ecd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-center" }
const _hoisted_2 = { class: "timeline-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-credit-card" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2-circle" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Checkout", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

import {computed} from "vue";
import {useStore} from "vuex";

export default /*#__PURE__*/_defineComponent({
  props: {step:Number},
  setup(__props) {

const props = __props


const store = useStore();
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", {
        class: _normalizeClass(__props.step > 0 ? 'timeline-active' : 'timeline-inactive')
      }, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.payment`)), 1)
      ], 2),
      _createElementVNode("li", {
        class: _normalizeClass(__props.step > 1 ? 'timeline-active' : 'timeline-inactive')
      }, _hoisted_6, 2)
    ])
  ]))
}
}

})